class FooterNavigation extends HTMLElement {
    constructor() {
        super();
        var elements = this.querySelectorAll('.footer-block__navigation-heading');

        for (var i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', (event) => {
                event.preventDefault();
                const wrapper = event.target.closest(".footer-block--menu");
                if (wrapper) {
                    this.toggle(wrapper);
                }
            });
        }

    }

    toggle(wrapper) {
        if (wrapper.classList.contains('active')) {
            wrapper.classList.remove('active')
        } else {
            wrapper.classList.add('active')
        }
    }
}

customElements.define('footer-navigation', FooterNavigation);
